export const RESTAURANT_PENDING_BACKGROUND = "#328dd675";
export const RESTAURANT_DECLINED_BACKGROUND = "#eb18186e";

const FLAGGED_ORDER_STATUS_IDS = [2, 4, 5];
const CLOSED_ORDER_STATUS_IDS = [6, 7];

const statusId = (item) => Number(item && item.status && item.status.id);

export const restaurantCellBackground = (item) => {
  if (!FLAGGED_ORDER_STATUS_IDS.includes(statusId(item))) return "";
  if (item.restaurant_approved_status === "pending") return RESTAURANT_PENDING_BACKGROUND;
  if (item.restaurant_approved_status === "declined") return RESTAURANT_DECLINED_BACKGROUND;
  return "";
};
